import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';

const useIsApplePayActive = ()=>{
    const { isApplePayExpressCheckoutEnabled  } = useFeatureToggles();
    const isApplePayActive = React.useMemo(()=>{
        var ref;
        return isApplePayExpressCheckoutEnabled && typeof ApplePaySession !== 'undefined' && (ApplePaySession === null || ApplePaySession === void 0 ? void 0 : (ref = ApplePaySession.canMakePayments) === null || ref === void 0 ? void 0 : ref.call(ApplePaySession));
    }, [
        isApplePayExpressCheckoutEnabled
    ]);
    return isApplePayActive;
};

export { useIsApplePayActive };
//# sourceMappingURL=use-is-apple-pay-active.js.map
